import React from "react";
import { useState, useEffect } from "react";
import { contvertHTMLToPlain, legendPosition } from "../../../../utils/constants";
import Plot from "../../../../utils/customPlotly";
import { isMobile } from "../../../../utils/deviceInfo";

export default function OptionsPiechart({
  question,
  option_response_matching_records,
  isFilterApplied,
}) {
  const [values, setvalues] = useState([]);
  const [labels, setLabels] = useState([]);
  useEffect(() => {
    const numVals = question.options.map((option) => {
      let optionResCount = 0;
      const option_doc = isFilterApplied
        ? option_response_matching_records.find(
            (x) => x._id === option.option_id
          )
        : option;

      if (!option_doc) {
        optionResCount = 0;
      } else {
        optionResCount = option_doc.totalResponses || option_doc.totalResponded;
      }

      return optionResCount;
    });

    const strLabels = question.options.map((option) =>
      contvertHTMLToPlain(option.text)
    );

    setvalues(numVals);
    setLabels(strLabels);
  }, []);

  return (
    <div>
      <Plot
        data={[
          {
            type: "pie",
            values: values,
            labels: labels.map((x) =>
              x.length > 100 ? `${x.slice(0, 100)}...` : x
            ),
            textinfo: "label+percent",
            textposition: "inside",
            automargin: true,
            hovertext: labels, // Full labels will be shown on hover
            hoverinfo: "text+percent", // Show full label and percent on hover
          },
        ]}
        layout={{
          legend: {
            y: legendPosition(labels.length),
            x: -0.05,
          },
          height: isMobile ? 300 : 400,
          width: isMobile ? 320 : 500,
          showlegend: true,
          margin: isMobile
            ? {
              t: 0,
              l: 0,
              r: 0,
              b: 0,
            }
            : {
                t: 50,
                l: 50,
                r: 50,
                b: 50,
              },
        }}
      />
    </div>
  );
}
